// Sportmailer landing pages post { name, height } so the iframe can match
// the form instead of sitting in a fixed aspect-ratio box.
window.addEventListener('message', (event) => {
    if (!event.origin.endsWith('sportmailer.com')) {
        return;
    }

    let message = event.data;
    if (typeof message === 'string') {
        try {
            message = JSON.parse(message);
        } catch {
            return;
        }
    }

    const height = Number(message?.height);
    const name = message?.name;
    if (!name || !Number.isFinite(height) || height <= 0) {
        return;
    }

    document.querySelectorAll('.embed--autoheight iframe').forEach((iframe) => {
        if (!iframe.src.includes(name)) {
            return;
        }

        const embed = iframe.closest('.embed');
        embed.style.setProperty('--embed-height', `${Math.ceil(height)}px`);
        embed.classList.add('is-sized');
        iframe.setAttribute('scrolling', 'no');
    });
});
